module.exports = __webpack_public_path__ + "img/ug201.48ecc784.png";